import { Redirect, useGlobalSearchParams } from 'expo-router';

import MarchMadnessLeagueView from '@/components/MarchMadnessLeagueView';
import NativeTabFocusGate from '@/components/navigation/NativeTabFocusGate';
import AppHeader from '@/components/AppHeader';
import { Box } from '@/components/ui/primitives';
import { useLeagueContext } from '@/contexts/LeagueContext';
import { getLandingHref, getLeagueHref } from '@/lib/routes';

export default function LeagueDraftRoute() {
  const routeParams = useGlobalSearchParams<{
    season?: string | string[];
    week?: string | string[];
  }>();
  const context = useLeagueContext();
  const id = context.id;

  if (!id || id === 'undefined') {
    return <Redirect href={getLandingHref()} />;
  }

  if (!context.isMarchMadness) {
    const seasonParam = Array.isArray(routeParams.season) ? routeParams.season[0] : routeParams.season;
    const weekParam = Array.isArray(routeParams.week) ? routeParams.week[0] : routeParams.week;

    return (
      <Redirect
        href={getLeagueHref(id, 'picks', {
          seasonId: seasonParam ?? null,
          weekId: weekParam ?? null,
        })}
      />
    );
  }

  const { league, resolvedSeasonId } = context;

  const headerTitle = league?.name ?? 'League';

  return (
    <NativeTabFocusGate>
      <Box flex={1} backgroundColor="background">
        <AppHeader title={headerTitle} currentLeagueId={id} allowBack={false} />
        <Box flex={1}>
          <MarchMadnessLeagueView
            leagueId={id}
            seasonId={resolvedSeasonId || ''}
            section="draft"
            currentUserId={context.league?.currentUserId}
            permissions={context.permissions}
          />
        </Box>
      </Box>
    </NativeTabFocusGate>
  );
}
